import type { IconNames } from '@dixa/lib-shared-habla';
import { v4 as uuid } from 'uuid';

import QueueFromPayload from 'components/powerFlowShared/components/queueFromPayload';
import {
  FlowNodeTypes,
  OptionT,
} from 'components/powerFlowShared/components/types';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import {
  FlowNode,
  flowNodeColor,
  InternalPortT,
  NodeT,
  NodeTypeComponent,
  RegisterPortT,
} from 'fable/flowEditor';

import { PowerEmailFlowExtraDataT } from '../PowerEmailFlow';
import { QueueModal as ActionModal } from '../modals/queue';

export type Payload = {
  queue: null | OptionT;
  queue_timeout?: {
    timeout_in_seconds: number;
    timeout_node_id: string | null;
  };
};
export type FlowEmailNodeQueueT = NodeT<FlowNodeTypes.QUEUE, Payload>;

const portTranslator = (node: FlowEmailNodeQueueT): RegisterPortT[] => {
  if (node.payload.queue_timeout) {
    const timeout = node.payload.queue_timeout;
    return [
      {
        id: uuid(),
        type: 'out',
        label: 'Timeout',
        connection: timeout.timeout_node_id || uuid(),
      },
    ];
  }

  return [];
};

export class QueueNode extends NodeTypeComponent<
  FlowEmailNodeQueueT,
  PowerEmailFlowExtraDataT
>() {
  static height = FlowNode.dimensions.h + 16;
  static icon: IconNames = 'users';
  static label = 'Queue';
  static helpText =
    'The queue is where you’d like your incoming conversations to automatically end up based on your company’s structure and priorities (e.g. Sales, Support).';
  static color = flowNodeColor.green;
  static translatePayload = formatPortsHelper(portTranslator);
  static ActionModal = ActionModal;
  static actionTrigger = { type: FlowNodeTypes.QUEUE };
  static updateConnection = (
    node: FlowEmailNodeQueueT,
    _port: InternalPortT,
    newConnection: string,
  ): FlowEmailNodeQueueT => {
    const payload: Payload = { ...node.payload };
    if (payload.queue_timeout) {
      payload.queue_timeout = {
        ...payload.queue_timeout,
        timeout_node_id: newConnection,
      };
    }

    return { ...node, payload };
  };

  triggerEdit = (): void => {
    const { onEdit, node } = this.props;
    onEdit(node, node.nodeType);
  };

  render() {
    return (
      <FlowNode
        color={QueueNode.color}
        icon={QueueNode.icon}
        label={QueueNode.label}
        text={
          <QueueFromPayload
            extraData={this.props.extraData}
            hasSettings
            node={this.props.node}
          />
        }
        onEdit={this.triggerEdit}
      />
    );
  }
}
